/**
 * GTIN (EAN-8, UPC-A, EAN-13, GTIN-14) validation. Barcodes come from cameras and keyboards,
 * so everything is checked before it is looked up or stored.
 */
const GTIN_LENGTHS = new Set([8, 12, 13, 14]);
/** Check digit for the digits before it (mod 10, weights 3/1 from the right). */
export function gtinCheckDigit(body) {
    let sum = 0;
    for (let i = 0; i < body.length; i++) {
        const digit = body.charCodeAt(body.length - 1 - i) - 48;
        sum += digit * (i % 2 === 0 ? 3 : 1);
    }
    return (10 - (sum % 10)) % 10;
}
export function isValidGtin(code) {
    if (!code || !/^\d+$/.test(code) || !GTIN_LENGTHS.has(code.length))
        return false;
    return gtinCheckDigit(code.slice(0, -1)) === Number(code.slice(-1));
}
/**
 * One spelling per product: UPC-A becomes EAN-13 (leading zero), a GTIN-14 with a leading
 * zero becomes EAN-13. EAN-8 stays as it is. Returns null for anything invalid.
 */
export function canonicalGtin(raw) {
    const code = (raw ?? '').replace(/[\s-]/g, '');
    if (!isValidGtin(code))
        return null;
    if (code.length === 12)
        return `0${code}`;
    if (code.length === 14 && code.startsWith('0'))
        return code.slice(1);
    return code;
}
//# sourceMappingURL=gtin.js.map